export default "__VITE_ASSET__DxjYaD51__"